import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import * as _ from 'lodash';
import { Menu } from 'antd';
import { ThemeProvider } from 'dlweb-components';
 
const MenuBar = ({$rootScope, menuItems, onClick}) => {

  const handleMenuClick = (item) => {

    const { key, payload, action } = _.find(menuItems, { key: item.key });

    if (typeof onClick === 'function') {
      onClick(action, key);
    }
    else {
      $rootScope.$broadcast(action, { key, action, payload });
    }
  }

  return (
    <ThemeProvider componentToken={{Menu: {itemBg: '#f9f9fa'}}}>
      <MenuContainer>
        <Menu
          mode="horizontal"
          selectable={false}
          items={menuItems}
          onClick={handleMenuClick}
        />
      </MenuContainer>
    </ThemeProvider>
  );
}

const MenuContainer = styled.div`
  line-height: 40px;
  width: 100%;
  color: #444;
  z-index: 9990;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  user-select: none;
`

export default MenuBar;